module.exports = __webpack_public_path__ + "static/media/planta.bd174871.png";


//////////////////
// WEBPACK FOOTER
// ./src/Img/planta.png
// module id = 290
// module chunks = 0